import BaseStore from '../../BaseStore';
import WOStatusModel from '../../../models/Maintenance/WorkOrder/PriorityModel';

class PriorityStore extends BaseStore {
  constructor(transportLayer) {
    super(WOStatusModel, transportLayer);
  }
}

export default PriorityStore;


// WEBPACK FOOTER //
// ./src/stores/Maintenance/WorkOrder/PriorityStore.js